import { render, staticRenderFns } from "./ReviewFeedbacks.vue?vue&type=template&id=0f0e2996&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ReviewFeedbacks.vue?vue&type=script&lang=js&"
export * from "./ReviewFeedbacks.vue?vue&type=script&lang=js&"
import style0 from "./ReviewFeedbacks.vue?vue&type=style&index=0&id=0f0e2996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0e2996",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
